import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import type { PasskeysQuerySorter } from './usePasskeysInfiniteQuery';

type PasskeysListQueryType = GenericListQueryKey<never, PasskeysQuerySorter>;

const passkeysFeatureKey = ['passkeys'] as const;

export const getPasskeysListQueryKey = (params: PasskeysListQueryType) =>
  generateListQueryKey({
    prefix: passkeysFeatureKey,
  })(params);

export const getPasskeysInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getPasskeysListQueryKey,
});
